import styled from 'styled-components';

export const Link = styled.a`
  page-break-inside: avoid !important;
  break-inside: avoid-page !important;
`;

export default Link;
